import type { ApiCallerT } from "./api/types";
import { createIncidenceTypesRepository } from "./repositories/incidenceTypes.repository";
import { createIncidenceTypesApi } from "./api/incidenceTypes.api";
import { incidenceTypesMapper } from "./mappers/incidenceTypes.mapper";

import { policyMapper } from "./mappers/policy.mapper";
import { createPolicyRepository } from "./repositories/policy.repository";
import { createPolicyApi } from "./api/policy.api";

import { collaboratorsMapper } from "./mappers/collaborators.mapper";
import { createCollaboratorsRepository } from "./repositories/collaborators.repository";
import { createCollaboratorsApi } from "./api/collaborators.api";

import { periodTypesMapper } from "./mappers/periodTypes.mapper";
import { createPeriodTypesRepository } from "./repositories/periodTypes.repository";
import { createPeriodTypesApi } from "./api/periodTypes.api";

export const buildIncidenceTypesRepository = ({ apiCaller }: { apiCaller: ApiCallerT }) => {
  const incidenceTypesApi = createIncidenceTypesApi(apiCaller);

  return createIncidenceTypesRepository({
    incidenceTypesApi,
    incidenceTypesMapper,
  });
};

export const buildPolicyRepository = ({ apiCaller }: { apiCaller: ApiCallerT }) => {
  const policyApi = createPolicyApi(apiCaller);

  return createPolicyRepository({
    policyApi,
    policyMapper,
  });
};

export const buildCollaboratorsRepository = ({ apiCaller }: { apiCaller: ApiCallerT }) => {
  const collaboratorsApi = createCollaboratorsApi(apiCaller);

  return createCollaboratorsRepository({
    collaboratorsApi,
    collaboratorsMapper,
  });
};

export const buildPeriodTypesRepository = ({ apiCaller }: { apiCaller: ApiCallerT }) => {
  const periodTypesApi = createPeriodTypesApi(apiCaller);

  return createPeriodTypesRepository({
    periodTypesApi,
    periodTypesMapper,
  });
};
